import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NgxSpinnerService } from "ngx-spinner";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { forkJoin, Observable, ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { ProcedimientosService } from 'src/app/_services/procedimientos.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';
import {
  isFirmaSubmitLocked,
  isGeneratePdfReady,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from '../_helpers/firma-submit.guard';
import { bloquearSiProcedimientoNoActivo } from '../_helpers/procedimiento-activo.util';
import { UnsubscribeOnDestroy } from '../_helpers/unsubscribe-on-destroy';
import { ClaveService } from '../_services/clave.service';
import { ClientFirmaLogService } from '../_services/client-firma-log.service';
import { PdfgenerateServiceEmvs } from '../_services/pdfgenerateEmvs/pdfgenerateEmvs.service';
import { SolicituCustomService } from '../_services/solicitud-custom.service';
import { NavService } from '../boton-listado/boton-listado.component.service';
import { NotificationI18nService } from '../core/util/notification-i18n.service';
import { ListadoTramitesEmvsService } from '../listado/listado-tramites-emvs/listado-tramites-emvs.service';
import { ConfirmDeleteDialogComponent } from '../modal/confirm-delete/confirm-delete-dialog.component';
import { EstadoTramite, TramiteEmvs } from '../listado/listado-tramites-emvs/tramite-emvs';
import { SamlRequest } from '../model/samltoken';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

declare const AutoScript: any;
declare const Constants: any;
//TODO:
@Component({
  selector: 'app-tramite-Dynamic',
  templateUrl: './tramite-dynamic.component.html',
  styleUrls: ['./tramite-dynamic.component.scss']
})
export class TramiteDynamicComponent extends UnsubscribeOnDestroy implements OnInit, OnDestroy {

  procedimiento: any = {};
  currentEnv = environment.environment;
  interested: any = {};
  currentUser: any = this.tokenStorageService.getUser();
  TProvincias: any = [];
  TMunicipios: any = [];
  estadosCiviles: any = [];
  gradosDiscapacidad: any = [];
  gradosDependencia: any = [];
  procedimientosVisibles: any = [];
  solicitudId: string = "";
  representanteId: string = "";
  circustanciaId: string = "";
  unidadId: string;
  activeAddress: any = {};
  municipios: any = this._servicioGeneral.getMunicipios();
  user: any = this._servicioUsuario.getCurrentUserFromServer();
  municipioNombre: string = "";
  submitted: boolean = false;
  isLogged: boolean = false;
  restauraPestania: boolean = true;
  genero: string = "";
  lopd: string = "";
  lastVisitedTab: string = "";
  provincias = this._servicioGeneral.getProvincias();
  isSigning: boolean = false;
  faltaFirma: boolean = false;
  mapDocumentos: any[] = [];
  arrayFicheros: any[] = [];
  uploadDocuments: boolean = false;
  firmaResultLocked = false;
  TVias: any = [];
  tramite: any = {}
  mensajeSpinner: string = 'Subiendo documentos...';
  representante: any;
  idProcedimiento: number = 0;
  tramitedinamico: any;

  tramitedinamicoSubmit: any;
  selectedOpcion: String = '';

  distritoId: number;
  vulnerabilidadId: number;
  autorizacionId: number;
  documentosId: number;

  instanciaId: number;
  subscription: Subscription;
  CSV: any;
  tabIndexSelected: number = 0;
  tipoFicherosPermitiros: any[] = ["application/pdf", "application/vnd.rar", "application/x-rar-compressed", "application/octet-stream", "application/x-zip-compressed", "image/jpg", "image/jpeg", "image/png", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
  userTk = this.tokenStorageService.getUser()
  isAdmin: boolean = Math.max(...this.userTk["rol"]) > 1;
  constructor(
    private tokenStorageService: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private _servicioUsuario: UserService,
    private _notificationI18n: NotificationI18nService,
    private _solicituCustomService: SolicituCustomService,

    private _router: Router,
    private _serviceProcedimientos: ProcedimientosService,
    private _route: ActivatedRoute,
    private generatePDF: PdfgenerateServiceEmvs,
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _navService: NavService,
    private spinner: NgxSpinnerService,
    private _claveService: ClaveService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private _clientFirmaLog: ClientFirmaLogService,
    private dialog: MatDialog
  ) {
    super();
  }

  dynamicForm: Array<FormGroup> = [];
  ngOnInit(): void {
    this.isLogged = !!this.tokenStorageService.getToken();

    if (!this.isLogged) {
      this._router.navigate(['/login'])
    }

    this.getProcedimiento();
    this.getNombreMunicipio();

    this.subscription = this._navService.navItem$

      .pipe(takeUntil(this.destroy$))
      .subscribe(item => {
        this.selectedOpcion = item;
      });
  }
  onSubmit(): any {
    this.isSigning = false;
    if (this.dynamicForm[this.tabIndexSelected] && !this.dynamicForm[this.tabIndexSelected].invalid) {

      var mostrarSpinnerSubmit: boolean = false;
      for (let e of this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos) {
        const index = this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos.findIndex(x => x.Nombre === e.Nombre);

        if (index >= 0
          && this.dynamicForm[this.tabIndexSelected]?.controls[e.Nombre]?.value) {
          if (e.Tipo === 'file') {
            this.dynamicForm[this.tabIndexSelected].controls[e.Nombre].reset;
            if (e.Documento && e.Documento.B64Document) mostrarSpinnerSubmit = true;
          }
          else if (e.Tipo === 'multiselect') {
            this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Valor = this.dynamicForm[this.tabIndexSelected].controls[e.Nombre].value.join(';');
          } else {
            this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Valor = this.dynamicForm[this.tabIndexSelected].controls[e.Nombre].value;
          }
        }
      }
      if (mostrarSpinnerSubmit) this.mostrarSpinnerMsg('Subiendo documentos');
      var pestania: string = this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].TagId;
      this.tramitedinamicoSubmit['LastVisitedTab'] = pestania;

      this._solicituCustomService
        .saveTramite(this.tramitedinamicoSubmit)

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            if (data && data.tramite) {
              this.tramite = data.tramite;
              this.solicitudId = this.tramite['IdTramite'];
              this.tramitedinamicoSubmit = data.tramite;
              this.ocultarSpinner();
              var indiceActual: number = this.tramitedinamicoSubmit.Pestanias.findIndex((x) => x.TagId === data.tramite.LastVisitedTab);
              if (indiceActual == this.tramitedinamicoSubmit.Pestanias?.length - 1) this.onSubmitPoliticas();
            }
            else if (data.responseError && data.responseCode) {
              this._notificationI18n.errorDynamic(data.responseError, 5000);
              this._router.navigate(['/perfil'], { queryParams: { action: 30 } });
            }
          },
          error: (err) => {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_ACTUALIZAR_EL_TRAMITE', 5000);
            this.ocultarSpinner();
          }
        });
      if (this.tabIndexSelected < this.tramitedinamicoSubmit.Pestanias?.length - 1)
        this.tabIndexSelected = this.tabIndexSelected + 1;
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  inicializaFormulario() {

    this.tabIndexSelected = 0;
    this.dynamicForm = [];

    console.log("Pestamia tramitedinamico: ", this.tramitedinamico.Pestanias);

    this.tramitedinamico.Pestanias.forEach(pestania => {

      let controlValidators = [];
      let formGroup = {};
      let indice = 0;
      console.log("Pestania: ", pestania);

      pestania?.Campos?.forEach(campo => {
        console.log("Campo: ", campo);


        controlValidators = [];
        if (campo.Validaciones && campo.Habilitado) {
          campo.Validaciones.forEach(validation => {
            if (validation.Nombre === 'Obligatorio') {
              if (campo.Tipo != 'checkbox') {
                controlValidators.push(Validators.required);
              } else {
                controlValidators.push(Validators.requiredTrue);
                /* controlValidators.push(Validators.pattern('^true$')); */
              }
            }
            if (validation.Nombre === 'Email') controlValidators.push(Validators.email);
            if (validation.Nombre === 'Pattern') controlValidators.push(Validators.pattern(validation.Validacion));
          });
        }

        if (campo.Tipo === 'multiselect') {
          formGroup[campo.Nombre] = [({
            value: campo.Valor ? campo.Valor.split(";") : [],
            disabled: !campo.Habilitado
          }), controlValidators];

        } else if (campo.Tipo != 'checkbox') {
          formGroup[campo.Nombre] = [({
            value: (campo.Tipo === 'file' ? campo.Documento : (campo.Valor ? campo.Valor || '' : (campo.Tipo === 'checkbox' ? false : this.recuperaValorDefecto(campo.NombreVariableDefecto, campo.NombreCampoDefecto)))),
            disabled: !campo.Habilitado
          }), controlValidators];
        } else {
          formGroup[campo.Nombre] = [campo.Valor != undefined ? Boolean(campo.Valor) : false, controlValidators];
        }

        if (campo.Tipo === 'file' && campo.Documento) formGroup[campo.Nombre].valid;

      });

      this.dynamicForm.push(this.formBuilder.group(formGroup));
      if (this.tramitedinamico?.LastVisitedTab
        && this.tramitedinamico?.LastVisitedTab === pestania.TagId) {
        var indiceActual: number = this.tramitedinamico?.Pestanias.findIndex((x) => x.TagId === this.tramitedinamico?.LastVisitedTab);
        if (indiceActual == this.tramitedinamico?.Pestanias?.length - 1) {
          this.tabIndexSelected = pestania.Orden - 1;
        }
        else {
          this.tabIndexSelected = pestania.Orden;
        }
      }
      indice = indice++;
    });
    this.tramitedinamicoSubmit = this.tramitedinamico;
  }
  /*   ngAfterViewChecked() {
      if(this.dynamicForm[this.tabIndexSelected] ){
        Object.keys(this.dynamicForm[this.tabIndexSelected].controls).forEach(key => {
          const index = this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos.findIndex(x => x.Nombre === key);
          if(this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Tipo == 'checkbox'){
            var valorTramite: boolean;
            if(this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Valor != undefined)
              valorTramite = Boolean(this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Valor)
            const ele = document.getElementById(key) as HTMLInputElement;
            if(valorTramite != undefined)this.dynamicForm[this.tabIndexSelected].get(key).patchValue(valorTramite, { emitEvent: true });
            if(ele) ele.checked = Boolean(this.dynamicForm[this.tabIndexSelected].get(key).value);
          }        
        });
  
        this.checksRestaurados = true;
      }
  
    } */
  /*   checkToggle(control: any){
      if(this.dynamicForm[this.tabIndexSelected].get(control.Nombre) ){
        const ele = document.getElementById(control.Nombre) as HTMLInputElement;
        const index = this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos.findIndex(x => x.Nombre === control.Nombre);
        if(this.dynamicForm[this.tabIndexSelected].get(control.Nombre).value == 'true'
           ||this.dynamicForm[this.tabIndexSelected].get(control.Nombre).value == true){         
          if(ele) ele.checked = false;
          this.dynamicForm[this.tabIndexSelected].get(control.Nombre).patchValue(false, { emitEvent: true });        
          if(index)this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Valor = false;
        }
        else{
          if(ele) ele.checked = true;
          this.dynamicForm[this.tabIndexSelected].get(control.Nombre).patchValue(true, { emitEvent: true });
          if(index)this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Valor = true;
        }
      };
    } */

  recuperaValorDefecto(nombreVariable: any, nombreCampo: string): any {
    try {
      if (this[nombreVariable] && (this[nombreVariable][nombreCampo] || (nombreCampo && nombreCampo.includes('.')))) {
        if (!nombreCampo.includes('.')) {
          var variable: any = this[nombreVariable];
          return variable[nombreCampo];
        }
        else {
          var arr: any = nombreCampo.split('.').map(function (item) {
            return item;
          });
          var campoBusqueda: any = this[nombreVariable];
          for (var index in arr) {
            if (arr.length == (Number(index) + 1)) {
              return campoBusqueda[arr[index]];
            }
            else {
              campoBusqueda = campoBusqueda[arr[index]];
            }
          }
        }
      }
      else if (this[nombreVariable] && !nombreCampo) {
        return this[nombreVariable];
      }
    }
    catch (e) {
      return '';
    }
    return '';
  }

  formProcedimiento: FormGroup = new FormGroup({
    procedimiento_id: new FormControl(""),
    tramite_id: new FormControl("")
  });

  formTramite: FormGroup = new FormGroup({
    procedimiento_id: new FormControl(""),
    genero: new FormControl("", Validators.required),
    tramite_id: new FormControl("")
  });

  formPoliticas: FormGroup = new FormGroup({
    politicas: new FormControl("", Validators.required)
  });





  formatDate(date) {
    const dateFormat = new Date(date);
    let month = '' + (dateFormat.getMonth() + 1);
    let day = '' + dateFormat.getDate();
    let year = dateFormat.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  private getUsuario(): void {
    this.currentUser = this.tokenStorageService.getUser();
    if (this.currentUser.email == null) {
      this._router.navigateByUrl('/perfil?action=20')
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.DEBE_COMPLETAR_LOS_DATOS_DE_SU_PERFIL_PARA_PODER_REALIZAR_TRAMITES');
    } else if (this.currentUser.email_confirmado == false) {
      this._router.navigateByUrl('/perfil?action=20')
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.DEBE_VERIFICAR_CUENTA_CORREO');
    }
    this.currentUser.direcciones.forEach(element => {
      if (element.isActive) {
        this.activeAddress = element;
      }
    });
    this.searchUser(this.currentUser.id);
  }
  searchUser(id: number): void {
    this._servicioGeneral.getUserId(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.currentUser = data.Usuario;
          this.tokenStorageService.setUser(data.Usuario, data.usuarioRepresenta);
        },
        error: (error) => {
          //console.log(error);
        }
      })
  }
  getNombreMunicipio(): void {
    this._servicioGeneral.getNombreMunicipio(this.activeAddress.province.id, this.activeAddress.municipality)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          return this.municipioNombre = data.nombre;
        },
        error: (error) => {
          //console.log(error);
        }
      })
  }

  private getProcedimiento(): void {
    this.idProcedimiento = +this._route.snapshot.paramMap.get("id");

    this._serviceProcedimientos
      .getProcedimiento(this.idProcedimiento)

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          console.log("Procedimiento 1: ", procedimiento);

          if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.isAdmin)) {
            return;
          }
          this._serviceProcedimientos
            .getProcedimientoCustomFormat(this.idProcedimiento)

            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (procedimiento) => {
                console.log("Procedimiento en next: ", procedimiento);

                this.procedimiento = procedimiento['Procedimiento'];
                this.listadoTramitesService.getProcedimientoCustomFormat(this.idProcedimiento, this.currentUser.id)
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: (data) => {

                      if (!data || !data['Procedimiento']) {
                        console.log("Procedimiento en if antes del método inicializaFormulario: ", data);
                        console.log("Procedimiento en if antes del método inicializaFormulario: ", this.procedimiento);

                        this.tramitedinamico = this.procedimiento;

                        this.inicializaFormulario();
                        this.genero = this.currentUser.genero;
                        let indicePestaniaDatosPersonales = -1;
                        if (this.tramitedinamico && this.tramitedinamico.Pestanias) {
                          for (let pestania of this.tramitedinamico.Pestanias) {
                            if (pestania.TagId === 'datosPersonales') indicePestaniaDatosPersonales = pestania.Orden - 1;
                          }
                        }
                        if (indicePestaniaDatosPersonales > -1 && this.currentUser.fechaNacimiento && this.dynamicForm[0]) {
                          if (this.dynamicForm[0].controls['fecha_nacimiento'] != undefined) this.dynamicForm[0].controls['fecha_nacimiento'].patchValue(this.formatDate(this.currentUser.fechaNacimiento), { emitEvent: false });
                        }
                        if (indicePestaniaDatosPersonales > -1 && this.currentUser.titulacion && this.dynamicForm[0]) {
                          if (this.dynamicForm[0].controls['titulacion'] != undefined) this.dynamicForm[0].controls['titulacion'].patchValue(this.currentUser.titulacion, { emitEvent: false });
                        }
                      }
                      else {
                        this.tramitedinamico = data['Procedimiento'];
                        this.solicitudId = this.tramitedinamico['IdTramite'];
                        this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_RECUPERADO_CON_EXITO');
                        this.inicializaFormulario();
                      }

                    },
                    error: (error) => {

                    }
                  });
              },
              error: (error) => {
                //console.log(error);
              }
            });
        },
        error: (error) => {
          //console.log(error);
        }
      });

    this.getUsuario();
  }

  getTramiteByUserId(idProcedimiento: number) {
    this.listadoTramitesService.getTramitesByuserId(this.currentUser.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          for (let item of data) {
            if (item.usuario_id.id == this.currentUser.id && item.custom) {
              if (item.procedimiento_id.id == idProcedimiento) {
                if (item.estadoFirma == 'NO_FINALIZADO') {
                  this.listadoTramitesService.tramiteCustom = item;
                  if (!this.tramitedinamicoSubmit && this.listadoTramitesService.tramite) this.tramitedinamicoSubmit = this.listadoTramitesService.tramiteCustom?.jsonTramite;
                } else if (item.estadoFirma == 'PENDIENTE_DE_FIRMA') {
                  this._router.navigate(['perfil'], { queryParams: { action: 30 } });
                }
              }
            }
          }
        },
        error: (error) => {

        }
      });
  }

  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(Constants.URL_BASE_SERVICES + "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES + "/afirma-signature-retriever/RetrieveService");
      AutoScript.sign(
        (data != undefined && data != null && data != "") ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback);

    } catch (e) {
      this._clientFirmaLog.noDisponible(this.solicitudId, 'tramite-dynamic');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO')
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById('certifcado') as HTMLInputElement).value = certB64;
    (document.getElementById('result') as HTMLInputElement).value = filenameB64;
    (document.getElementById('error') as HTMLInputElement).value = '';
    document.forms["firma"].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }
  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.solicitudId, 'tramite-dynamic', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById('certifcado') as HTMLInputElement).value = '';
    (document.getElementById('error') as HTMLInputElement).value = errorMessage + ". Se ha habilitado la opción para firmar con Cl@ve";
    document.forms["firma"].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }

  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;

    let base64Document = (document.getElementById('result') as HTMLInputElement).value;
    let errorFirma = (document.getElementById('error') as HTMLInputElement).value;

    let certificado = atob((document.getElementById('certifcado') as HTMLInputElement).value);

    if (certificado.includes(this.tokenStorageService.getUser().numero_documento) || certificado == '') {

      var form: FormGroup = new FormGroup({
        pdfFirmado: new FormControl("")
      });
      this.pdfProcedimiento(errorFirma, base64Document, form);

    } else {
      releaseFirmaSubmitLock(this);
      this.faltaFirma = true;
      this.isSigning = false;
      this._servicioUsuario
        .clearCurrentTipoFirma()

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      this._clientFirmaLog.certificadoInvalido(this.solicitudId, 'tramite-dynamic');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
      this.ocultarSpinner();
    }
  }

  public pdfProcedimiento(errorFirma: string, base64Document: string, formDoc: FormGroup) {
    if (this.uploadDocuments) {
      return;
    }
    this.ocultarSpinner()
    if ((errorFirma == '' && base64Document != '')) {
      this._clientFirmaLog.exito(this.solicitudId, 'tramite-dynamic');
      this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_FIRMADO_EL_DOCUMENTO');

      formDoc.controls['pdfFirmado'].setValue({ nameDocument: 'comprobante_solicitud_tramite_.pdf', typeDocument: 'application/pdf', b64Document: base64Document, csv: this.CSV }, { emitEvent: false });
      this.downloadPdf(base64Document, 'comprobante_solicitud_tramite');
      this.uploadDocuments = true;
      this._solicituCustomService
        .savePdf(formDoc.controls['pdfFirmado'].value, this.solicitudId)

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            let tramite: any = {
              IdTramite: this.solicitudId
            };
            this.mostrarSpinnerMsg('Registrando el trámite...');
            this._solicituCustomService.updateEstadoTramite(tramite)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (data) => {
                  releaseFirmaSubmitLock(this);
                  this._clientFirmaLog.subidaOk(this.solicitudId, 'tramite-dynamic');
                  this._router.navigate(['/perfil'], { queryParams: { action: 30 } });
                  this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
                  this.listadoTramitesService.tramite = null;
                  this.ocultarSpinner();
                },
                error: (error) => {
                  releaseFirmaSubmitLock(this);
                  this.ocultarSpinner();
                }
              });

          },
          error: (err) => {
            releaseFirmaSubmitLock(this);
            this._clientFirmaLog.subidaError(this.solicitudId, 'tramite-dynamic', err?.message);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.HUBO_PROBLEMAS_PARA_FINALIZAR_SU_TRAMITE_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
            this._router.navigate(['/inicio']);
          }
        });
    } else {
      this._clientFirmaLog.error(this.solicitudId, 'tramite-dynamic', undefined, errorFirma || 'Firma cancelada o fallida');
      this.mostrarSpinnerMsg('Guardando datos completados...')
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_FIRMAR_DOCUMENTO', 5000)
      this._servicioGeneral.generatePdfCustom(this.tramite.IdTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
          formDoc.addControl('pdfNoFirmado', new FormControl, { emitEvent: false });
          formDoc.controls['pdfNoFirmado'].setValue({ nameDocument: 'comprobante_solicitud_tramite_.pdf', typeDocument: 'application/pdf', b64Document: data.file, csv: this.CSV }, { emitEvent: false });
          this._solicituCustomService
            .savePdf(formDoc.controls['pdfNoFirmado'].value, this.solicitudId)

            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (data) => {
                let tramite: TramiteEmvs = {
                  id: +this.solicitudId,
                  estadoFirma: EstadoTramite.PENDIENTE_DE_FIRMA,
                  estado: true
                };
                forkJoin([
                  this._solicituCustomService.updateTramite(tramite),
                  this._servicioUsuario.clearCurrentTipoFirma()
                ]).pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: () => {
                      releaseFirmaSubmitLock(this);
                      this._router.navigate(['/perfil'], { queryParams: { action: 30 } }).then(() => { this.ocultarSpinner() });
                    },
                    error: (err) => {
                      // Si no se puede dejar el tramite en PENDIENTE_DE_FIRMA hay que avisar:
                      // en el listado quedaria sin accion de firma y solo se podria eliminar.
                      releaseFirmaSubmitLock(this);
                      this._clientFirmaLog.error(this.solicitudId, 'tramite-dynamic', undefined, 'No se pudo dejar el tramite en PENDIENTE_DE_FIRMA');
                      this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDO_DEJAR_EL_TRAMITE_PENDIENTE_DE_FIRMA_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                      this._router.navigate(['/perfil'], { queryParams: { action: 30 } }).then(() => { this.ocultarSpinner() });
                    }
                  });
              },
              error: (err) => {
                releaseFirmaSubmitLock(this);
                this._notificationI18n.error('NOTIFICATION.MESSAGE.HUBO_PROBLEMAS_PARA_FINALIZAR_SU_TRAMITE_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                this._router.navigate(['/inicio']).then(() => { this.ocultarSpinner() });
              }
            });
          },
          error: (err) => {
            // Sin este handler un fallo al regenerar el PDF dejaba el tramite en
            // NO_FINALIZADO y el spinner colgado, sin ninguna traza para el usuario.
            releaseFirmaSubmitLock(this);
            this._clientFirmaLog.error(this.solicitudId, 'tramite-dynamic', undefined, 'No se pudo regenerar el PDF tras el fallo de firma');
            this._notificationI18n.errorPdfGeneration(err?.error, 5000);
            this.ocultarSpinner();
          }
        });
    }
  }

  public downloadPdf(base64Document, fileName) {
    if (base64Document) {
      const source = 'data:application/pdf;base64,' + base64Document;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}.pdf`
      link.click();
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    if (file) {
      reader.readAsBinaryString(file);
      reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    }
    return result;
  }

  deleteTramite() {
    const nombre = this.tramitedinamico?.Nombre || this.tramitedinamico?.nombre || this.procedimiento?.nombre || '';
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Eliminar trámite',
        message: `¿Seguro que quieres eliminar el trámite «${nombre}»? El trámite quedará dado de baja.`,
        confirmLabel: 'Eliminar'
      },
      panelClass: 'gu-dialog-panel'
    });
    ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.confirmDelete();
      });
  }

  confirmDelete() {
    if (this.solicitudId != '') {

      this.listadoTramitesService.deleteTramiteFormCustomById(this.solicitudId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_ELIMINADO_CON_EXITO');
            this._router.navigate(['/inicio']);
            //this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    } else {
      this._notificationI18n.success('NOTIFICATION.MESSAGE.HA_SALIDO_DEL_TRAMITE_CON_EXITO');
      this._router.navigate(['/inicio']);
    }
  }

  restoreConsulta() {
    //TODO paso final 2 formulario
  }

  restauraPestaniaSeleccionada(pestania: any) {

    this.tabIndexSelected = pestania.Orden - 1;

  }

  volver() {
    if (this.tabIndexSelected
      && this.tabIndexSelected > 0) {

      this.tabIndexSelected = this.tabIndexSelected - 1;
    }
  }
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('tramite_dynamic_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('tramite_dynamic_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('tramite_dynamic_spinner');
  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }

  getMensajeError(control: any) {
    const formControl = this.dynamicForm[this.tabIndexSelected].get(control.Nombre);
    if (control.Validaciones) {
      for (let validacion of control.Validaciones) {
        if (formControl.hasError(validacion.Nombre.toLowerCase()) || formControl.hasError(validacion.Validacion)) {
          return validacion.Mensaje;
        }
      }
    }
    return '';
  }
  esCampoObligatorio(control: any) {
    if (control.Tipo == 'textarea') return false;
    if (control.Validaciones) {
      for (let validacion of control.Validaciones) {
        if (validacion.Nombre.toLowerCase() == 'obligatorio') {
          return true;
        }
      }
    }
    return false;
  }
  getClassDiv(control: any) {
    if (control.DivClass) {
      return control.DivClass;
    }
    else {
      return 'col-xs-12 col-sm-6 col-md-4 spacing-box';
    }
  }
  onFileChange(event, key: string) {
    if (event.target.files.length > 0) {
      let formControl: any = this.dynamicForm[this.tabIndexSelected];
      const file = event.target.files[0];
      const maxSize = 30 * 1024 * 1024; // 30 MB en bytes
      if (file.size > maxSize) {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_SUPERA_LOS_30MB', 5000);
        formControl.controls[key].setErrors({ 'incorrect': true });
        this.removeFile(key);
      }
      else if ((!file.type && !file.name.endsWith('.rar')) || (this.tipoFicherosPermitiros.findIndex(x => x === file.type) < 0 && !file.name.endsWith('.rar'))) {

        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_NO_ES_TIENE_UN_FORMATO_VALIDO_LOS_FORMATOS_VALIDOS_SON_RAR_ZIP_JPG_PD', 5000);
        formControl.controls[key].setErrors({ 'incorrect': true });
        this.removeFile(key);

      }
      else {
        const index = this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos.findIndex(x => x.Nombre === key);
        if (index >= 0) {
          this.convertFile(file)
            .pipe(takeUntil(this.destroy$))
            .subscribe(base64 => {
              this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Documento =
              {
                Nombre: file.name,
                Tipo: file.type,
                B64Document: base64,
                IdTramite: this.solicitudId,
                Id: null,
                Pestania: this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected].Nombre,
                Campo: this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Nombre
              }
            });
        }
      }
    }
    else {
      const index = this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos.findIndex(x => x.Nombre === key);
      if (index >= 0) {
        this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Documento = null;
      }
    }
  }
  removeFile(key: string): void {
    if (key) {
      const index = this.tramitedinamicoSubmit?.Pestanias[this.tabIndexSelected]?.Campos.findIndex(x => x.Nombre === key);
      if (index >= 0) {
        this.dynamicForm[this.tabIndexSelected].controls[key]?.patchValue(null, { emitEvent: true });
        this.tramitedinamicoSubmit.Pestanias[this.tabIndexSelected].Campos[index].Documento = null;
      }
    }
  }
  onSubmitPoliticas(): any {
    this.isSigning = true;
    if (this.selectedOpcion == "Firmar con Autofirma") {
      this.mostrarSpinnerMsg("Solicitando firma...");

      this._servicioGeneral.generatePdfCustom(this.tramite.IdTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data: any) => {
            if (isGeneratePdfReady(data)) {
              this.CSV = data.csv;
              this._clientFirmaLog.iniciada(this.tramite.IdTramite, 'tramite-dynamic');
              this.singFile(data.file);
            }
            else {
              this.isSigning = false;
              this.ocultarSpinner();
              this._notificationI18n.errorPdfGeneration(data, 5000);
            }
          },
          error: (error) => {
            console.error(error);
            this.isSigning = false;
            this.ocultarSpinner();
            this._notificationI18n.errorPdfGeneration(error?.error, 5000);
          },
        });
    } else {
      this._claveService.iniciaFirma(this.tramite.IdTramite, 1)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data: SamlRequest) => {
            this.post(data.nodeService, {
              SAMLRequest: data.SamlRequest,
              RelayState: data.RelayState,
            });
          },
          error: (error) => console.error(error),
        });
    }
  }

}
